var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomersCountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 5.33333V0H0.666504V24H27.3332V5.33333H13.9998ZM11.3332 21.3333H3.33317V18.6667H11.3332V21.3333ZM11.3332 16H3.33317V13.3333H11.3332V16ZM11.3332 10.6667H3.33317V8H11.3332V10.6667ZM11.3332 5.33333H3.33317V2.66667H11.3332V5.33333ZM24.6665 21.3333H13.9998V8H24.6665V21.3333ZM21.9998 10.6667H16.6665V13.3333H21.9998V10.6667ZM21.9998 16H16.6665V18.6667H21.9998V16Z",
    fill: "#2B2B5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersCountIcon);
export default __webpack_public_path__ + "static/media/customersCountIcon.ceac41698df2a41720187a5df5960b63.svg";
export { ForwardRef as ReactComponent };